"use client"

import { useId } from "react"

const ASCII_BANNER = `
                              AAAAAAAA                                                                                                                                 
                          AAAAAAAAAAA                                                                                                                            
                       AAAAAAAAAAAAAA                                          AAAA              AAAAAAAAAAAAAAAAAA  AAAA                                              
                    AAAAAAAAAAAAAAAAA                                          AAAA              AAAAAAAAAAAAAAAAAA  AAAA                                              
                  AAAAAAAAAAAAAAAAAAA                                          AAAA              AAAA                                                                  
                AAAAAAAAAAAAAAAAAAAA           AAAAAAAAA        AAAAAAAAAA     AAAA      AAAAA   AAAA                AAAA   AAAA  AAAAAAA     AAAAAAAAAAAAAAAA         
              AAAAAAAAAAAAAAAAAAAAAA        AAAAAAAAAAAAAAA   AAAAAAAAAAAAAA   AAAA    AAAAAAA   AAAA                AAAA   AAAAAAAAAAAAAAA   AAAAAAAAAAAAAAAA         
            AAAAAAAAAAAAAAAAAAAAAAAA       AAAAAA    AAAAAA   AAAAA    AAAAAA  AAAA   AAAAAA     AAAAAAAAAAAAAAAA    AAAA   AAAAAAAA  AAAAAA           AAAAAA          
           AAAAAAAAAAAAAAAAAAAAAAAAA       AAAA        AAAA  AAAAAA      AAAA  AAAAAAAAAAA       AAAAAAAAAAAAAAAA    AAAA   AAAA       AAAAA         AAAAAAA           
         AAAAAAAAAAAAAAAAAAAAAAAAAAAA         AAAAAAAAAAAAA   AAAAAAAAAAA      AAAAAAAAAA        AAAAAAAAAAAAAAAA    AAAA   AAAA        AAAA        AAAAAA             
        AAAAAAAAAAAAAAAAAAAAAAAAAAAAA       AAAAAAAAAAAAAAA    AAAAAAAAAAAAAA  AAAAAAAAAAA       AAAA                AAAA   AAAA        AAAA      AAAAAAA              
       AAAAAAAAAAAAAAAAAAAAAAAAAAAAAA      AAAAA       AAAA        AAAAAAAAAA  AAAAA  AAAAA      AAAA                AAAA   AAAA        AAAA    AAAAAAA                
      AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA    AAAAA        AAAA  AAAA        AAAA  AAAA    AAAAA     AAAA                AAAA   AAAA        AAAA   AAAAAA                  
     AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA    AAAAAA    AAAAAAA  AAAAAA    AAAAAA  AAAA     AAAAAA   AAAA                AAAA   AAAA        AAAA AAAAAAAAAAAAAAAA          
    AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA    AAAAAAAAAAAAAAAA   AAAAAAAAAAAAAA   AAAA      AAAAAA  AAAA                AAAA   AAAA        AAAA AAAAAAAAAAAAAAAAA         
   AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA      AAAAAAAA AAAA      AAAAAAAAA     AAAA       AAAAA  AAAA                AAAA   AAAA        AAAA AAAAAAAAAAAAAAAAA         
  AAAAAAA  AAAAAAAAA  AAAAAAAAA AAAAAAAAA                                                                                                                              
`

interface AsciiBannerProps {
  className?: string
  size?: 'small' | 'medium' | 'large'
}

export function AsciiBanner({ className = "", size = 'medium' }: AsciiBannerProps) {
  const baseId = useId()
  const cid = baseId.replace(/:/g, '')

  return (
    <>
      {/* Inline <style> renders during SSR — prevents FOUC */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes askfinz-rgb-wave-${cid} {
          0% { background-position: 200% 50%; }
          100% { background-position: 0% 50%; }
        }
        .askfinz-ab-wrap-${cid} {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          overflow: hidden;
          container-type: size;
          background-color: rgb(244 244 245);
        }
        :is(.dark .askfinz-ab-wrap-${cid}) {
          background-color: rgb(24 24 27 / 0.5);
        }
        .askfinz-ab-text-${cid} {
          white-space: pre;
          line-height: 1;
          font-size: 0.72cqw;
          font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
          letter-spacing: -0.05em;
          background: linear-gradient(
            90deg,
            #ff0000, #ff7f00, #ffff00, #00ff00, #00ffff, #ff00ff, #ff0000
          );
          background-size: 200% 100%;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: askfinz-rgb-wave-${cid} 8s linear infinite;
        }
      `}} />
      <div className={`askfinz-ab-wrap-${cid} ${className}`}>
        <div className={`askfinz-ab-text-${cid} text-center`}>
          {ASCII_BANNER}
        </div>
      </div>
    </>
  )
}
